<template>
  <div>
    <router-view />
    <modal-invoke />
  </div>
</template>
<script>
import modalInvoke from "./components/modalCookie";
export default {
  components: {
    modalInvoke
  }
};
</script>
<style>
  #my-modal{
   overflow-x: scroll;
  }
</style>